(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bh-product-drawers"] && !Shopify.designMode) return;
  try {
    // Shows the size chart of the tee cut just picked (see the size_charts comment above).
  document.addEventListener('shopify:product:select', (event) => {
    const section = event.target.closest('.shopify-section');
    const cuts = (event.selectedOptions ?? []).map((option) => option.value.split(' – ')[0]);
    for (const chart of section?.querySelectorAll('[data-size-chart-for]') ?? []) {
      chart.hidden = !cuts.includes(chart.dataset.sizeChartFor);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
